import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store/store';
import BackToStorefront from './BackToStorefront';

interface AuthCardProps {
  title: string;
  subtitle: ReactNode;
  icon?: ReactNode;
  children: ReactNode;
}

export const authLabelClass =
  'block font-dmsans text-[12px] font-medium uppercase tracking-[0.04em] text-gray-500 mb-[8px]';

export const authInputClass =
  'w-full h-[48px] border border-gray-200 bg-gray-100 rounded-lg px-[16px] font-dmsans text-[15px] text-gray-800 placeholder:text-gray-400 focus:outline-none focus:bg-white focus:border-[#1E6DB4] focus:ring-2 focus:ring-[#1E6DB4]/15 transition-all';

export const authButtonClass =
  'w-full h-[52px] rounded-lg font-dmsans font-semibold text-[16px] flex items-center justify-center shadow-sm transition-colors';

export default function AuthCard({
  title,
  subtitle,
  icon,
  children,
}: AuthCardProps) {
  const navigate = useNavigate();
  const { routesPrefix } = useSelector((state: RootState) => state.setup);
  const storeInfo = useSelector((state: RootState) => state.products.storeInfo);

  return (
    <div className="w-full min-h-screen !overflow-x-hidden bg-gradient-to-b from-gray-100 to-gray-50 px-4 py-[40px]">
      <div className="w-full max-w-[420px] m-auto bg-white rounded-2xl border border-gray-200 shadow-[0_12px_40px_rgba(15,23,42,0.06)] px-[24px] sm:px-[32px] py-[36px]">
        {/* Store branding */}
        <div
          className="flex flex-col items-center gap-[14px] cursor-pointer mb-[32px]"
          onClick={() => navigate(`${routesPrefix}`)}
        >
          {storeInfo?.coverImage && (
            <img
              src={storeInfo.coverImage}
              className="w-[80px] h-[80px] rounded-full object-contain"
              alt={storeInfo?.name}
            />
          )}
          {storeInfo?.name && (
            <span className="font-dmsans font-bold text-[18px] text-gray-900 text-center">
              {storeInfo.name}
            </span>
          )}
        </div>

        {icon && (
          <div className="w-[56px] h-[56px] mx-auto mb-[20px] rounded-full bg-[#1E6DB4]/10 border border-[#1E6DB4]/20 flex items-center justify-center text-[#1E6DB4]">
            {icon}
          </div>
        )}
        <h1
          className={`font-dmsans font-bold text-[26px] leading-tight text-gray-900 ${icon ? 'text-center' : ''}`}
        >
          {title}
        </h1>
        <p
          className={`font-dmsans text-[15px] leading-relaxed text-gray-500 mt-[6px] mb-[28px] ${icon ? 'text-center' : ''}`}
        >
          {subtitle}
        </p>

        {children}
      </div>
      <BackToStorefront className="!mt-[20px]" />
    </div>
  );
}
